export enum CertificateStatus {
  NOT_UPLOADED = "NOT_UPLOADED",
  PENDING = "PENDING",
  PROCESSED = "PROCESSED",
  REJECTED = "REJECTED",
}
